import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  model,
  inject,
  AfterViewInit,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe, formatDate } from '@angular/common';
import { MatTableFilter } from 'mat-table-filter';
import { MatPaginator } from '@angular/material/paginator';

export interface ColumnSchema {
  key: string;
  label: string;
  type?: 'text' | 'action' | 'checkbox' | 'download' | 'filter' | 'select' | 'autocomplete' | 'date' | 'time' | 'chips';
  options?: any[]; // For select or autocomplete types
  valueMap?: { [key: string]: string }; // Maps raw values to display labels
  isClickable?: boolean; // Renders cell as a clickable link
  clickableChip?: boolean; // When combined with isClickable, renders as a chip (no remove icon) instead of an <a>

  validations?: any[];
  isDisabled?: boolean;
  pipe?: string; // For date or other formatting
  filterType?: string; // For filter rendering
  editableColumn?: boolean; // Makes cell editable as text input on edit
  tooltipFormatter?: (elem: any) => string; // Builds tooltip text for 'view' type columns
}

@Component({
  selector: 'app-table-with-action',
  standalone: false,
  templateUrl: './table-with-action.component.html',
  styleUrl: './table-with-action.component.scss',
})
export class TableWithActionComponent implements AfterViewInit, OnChanges {
  @Input() data: any[] = [];
  @Input() columnsSchema: ColumnSchema[] = [];
  @Input() filterColumns: string[] = [];
  @Input() tableColumns: string[] = [];
  @Input() excelColumns: string[] = [];
  @Input() fileName: string = '';
  @Input() selectOptions: { [key: string]: { value: string; label: string }[] } = {};
  readonly selectedTab = model<any>();

  @Output() actionClick = new EventEmitter<{ item: any; actionType: string }>();
  @Output() rowSelected = new EventEmitter<any[]>();
  @Output() onApprove = new EventEmitter<any>();
  @Output() onReject = new EventEmitter<any>();
  @Output() onSave = new EventEmitter<{ original: any; updated: any }>();

  editingRow: any = null;
  editingRowData: any = null;

  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [];
  selection = new SelectionModel<any>(true, []);
  showFilter: boolean = false;
  filterEntity: object = {};
  filterType: MatTableFilter;
  allData: any[] = [];
  selectFilters: { [key: string]: string } = {};
  dateRangeFilters: { [key: string]: { start: Date | null; end: Date | null } } = {};
  timeRangeFilters: { [key: string]: { start: string | null; end: string | null } } = {};
  datePipe = inject(DatePipe);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue || changes['columnsSchema']?.currentValue) {
      this.allData = [...(this.data ?? [])];
      this.applyAllFilters();
      this.setDisplayedColumns();
    }

    if (changes['columnsSchema']?.currentValue) {
      this.columnsSchema
        .filter((c) => c.type === 'date' || c.filterType === 'date')
        .forEach((col) => {
          if (!this.dateRangeFilters[col.key]) this.dateRangeFilters[col.key] = { start: null, end: null };
        });
      this.columnsSchema
        .filter((c) => c.type === 'time' || c.filterType === 'time')
        .forEach((col) => {
          if (!this.timeRangeFilters[col.key]) this.timeRangeFilters[col.key] = { start: null, end: null };
        });
    }

    this.filterType = MatTableFilter.ANYWHERE;
  }

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  private setDisplayedColumns(): void {
    // Extract column keys from the schema
    this.displayedColumns = this.columnsSchema.map((col) => col.key);
    console.log('columnsSchema ', this.columnsSchema);
  }

  downloadTableData() {
    const tableData = [];
    this.data.forEach((element) => {
      const tmp = {};
      this.tableColumns.forEach((head) => {
        tmp[head] = element[head];
      });
      tableData.push(tmp);
    });
    this.downloadApprovalTable(tableData, this.excelColumns, this.fileName);
  }

  downloadApprovalTable(data, hdrs, fileName) {
    const tableData_ = data.length;
    let rowDataApp_ = '';
    for (let i = 0; i < tableData_; i++) {
      let lineApp_ = '';
      let dojDate_;
      for (const elem_ in data[i]) {
        if (lineApp_ != '') {
          lineApp_ = lineApp_ + ',';
        }
        const datefields = this.columnsSchema.filter((elem) => elem.pipe && elem.key === elem_);

        if (datefields.length !== 0 && data[i][elem_]) {
          let _doj, _year_d, _month_new_d, _day_d;

          dojDate_ = formatDate(data[i][elem_].toString(), 'dd-MMM-yyyy', 'en');
          lineApp_ = lineApp_ + dojDate_;
        } else if (data[i][elem_]) {
          const cellValue = data[i][elem_] + '';
          if (['+', '-', '=', '@'].some((c) => cellValue.startsWith(c))) {
            lineApp_ = lineApp_ + '=\"' + cellValue + '\"';
          } else {
            lineApp_ = lineApp_ + '\"' + cellValue + '\"';
          }
        } else {
          lineApp_ = lineApp_ + '\"' + '\"';
        }
      }
      rowDataApp_ = rowDataApp_ + lineApp_ + '\r\n';
    }
    const dwnldData = hdrs.join(',') + '\r\n' + rowDataApp_;
    if (dwnldData.split('\n').length - 1 >= 1) {
      const anchorApp = document.createElement('a');
      anchorApp.href = URL.createObjectURL(new Blob([dwnldData], { type: 'text/csv' }));
      anchorApp.download = fileName + '.csv';
      anchorApp.click();
    }
  }

  filterTble(column) {
    if (this.showFilter) {
      const filterCols = this.filterColumns;
      if (filterCols.indexOf(column) != -1) {
        return true;
      } else {
        return false;
      }
    } else {
      this.filterEntity = {};
      this.selectFilters = {};
      this.dateRangeFilters = {};
      this.timeRangeFilters = {};
      return false;
    }
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
    if (!this.showFilter) {
      this.filterEntity = {};
      this.selectFilters = {};
      this.dateRangeFilters = {};
      this.timeRangeFilters = {};
      this.applyAllFilters();
    } else {
      this.columnsSchema
        .filter((c) => c.type === 'date' || c.filterType === 'date')
        .forEach((col) => {
          this.dateRangeFilters[col.key] = { start: null, end: null };
        });
      this.columnsSchema
        .filter((c) => c.type === 'time' || c.filterType === 'time')
        .forEach((col) => {
          this.timeRangeFilters[col.key] = { start: null, end: null };
        });
    }
  }

  approveReq(elem) {
    this.onApprove.emit(elem);
  }

  rejectReq(elem) {
    this.onReject.emit(elem);
  }

  startEdit(row: any) {
    this.editingRow = row;
    this.editingRowData = { ...row };
  }

  saveEdit() {
    this.onSave.emit({ original: this.editingRow, updated: this.editingRowData });
    this.editingRow = null;
    this.editingRowData = null;
  }

  cancelEdit() {
    this.editingRow = null;
    this.editingRowData = null;
  }

  isRowEditing(row: any): boolean {
    return this.editingRow === row;
  }

  onCellClick(col: ColumnSchema, elem: any) {
    // Emit event for parent to handle all click logic
    this.actionClick.emit({ item: elem, actionType: col.key });
  }
  applyAllFilters() {
    const selectCols = this.columnsSchema.filter((c) => c.type === 'select');
    this.dataSource.data = this.allData.filter((row) => {
      // --- select filters ---
      const passesSelect = selectCols.every((col) => {
        const val = this.selectFilters[col.key];
        if (!val) return true;
        const rowVal = row[col.key]?.toString();
        if (col.valueMap) {
          const selectedLabel = (col.valueMap[val] ?? val).toLowerCase();
          const rowLabel = (col.valueMap[rowVal] ?? rowVal ?? '').toLowerCase();
          return rowLabel === selectedLabel;
        }
        return rowVal?.toLowerCase() === val.toLowerCase();
      });
      if (!passesSelect) return false;

      // --- date range filters ---
      const passesDate = Object.keys(this.dateRangeFilters).every((key) => {
        const range = this.dateRangeFilters[key];
        if (!range.start && !range.end) return true;
        const rowDate = row[key] ? new Date(row[key]) : null;
        if (!rowDate) return false;
        if (range.start) {
          const startOfDay = new Date(range.start);
          startOfDay.setHours(0, 0, 0, 0);
          if (rowDate < startOfDay) return false;
        }
        if (range.end) {
          const endOfDay = new Date(range.end);
          endOfDay.setHours(23, 59, 59, 999);
          if (rowDate > endOfDay) return false;
        }
        return true;
      });
      if (!passesDate) return false;

      // --- time range filters ---
      return Object.keys(this.timeRangeFilters).every((key) => {
        const range = this.timeRangeFilters[key];
        if (!range.start && !range.end) return true;
        const rowMinutes = this.parseTimeToMinutes(row[key] || '');
        if (rowMinutes === null) return false;
        if (range.start) {
          const startMinutes = this.parseTimeToMinutes(range.start);
          if (startMinutes !== null && rowMinutes < startMinutes) return false;
        }
        if (range.end) {
          const endMinutes = this.parseTimeToMinutes(range.end);
          if (endMinutes !== null && rowMinutes > endMinutes) return false;
        }
        return true;
      });
    });
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
      this.paginator.firstPage();
    }
  }

  getDistinctColumnValues(colKey: string): string[] {
    const values = this.allData.map((row) => row[colKey]?.toString()).filter((v) => v != null && v !== '');
    return [...new Set(values)];
  }

  onSelectFilterChange(key: string, value: string) {
    this.selectFilters[key] = value;
    this.applyAllFilters();
  }

  onDateRangeChange(key: string, start: Date | null, end: Date | null) {
    if (!this.dateRangeFilters[key]) {
      this.dateRangeFilters[key] = { start: null, end: null };
    }
    if (start !== null) this.dateRangeFilters[key].start = start;
    if (end !== null) this.dateRangeFilters[key].end = end;
    this.applyAllFilters();
  }

  parseTimeToMinutes(timeStr: string): number | null {
    if (!timeStr) return null;
    const match = timeStr.match(/(\d+):(\d+)(?::(\d+))?\s*(AM|PM)?/i);
    if (!match) return null;
    let hours = parseInt(match[1]);
    const minutes = parseInt(match[2]);
    const period = match[4]?.toUpperCase();
    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;
    return hours * 60 + minutes;
  }

  clearDateFilter(key: string) {
    this.dateRangeFilters[key] = { start: null, end: null };
    this.applyAllFilters();
  }

  clearTimeFilter(key: string) {
    this.timeRangeFilters[key] = { start: null, end: null };
    this.applyAllFilters();
  }
}
